/**
 * KeyboardShortcutsHelp - Klavye Kısayolları Yardım Paneli
 * Ctrl+/ ile açılıp kapanır
 */
import React, { useState, useEffect } from 'react';
import './KeyboardShortcutsHelp.css';

const SHORTCUTS = [
    {
        category: 'Genel', shortcuts: [
            { keys: ['Ctrl', 'S'], description: 'Kaydet' },
            { keys: ['Ctrl', 'K'], description: 'Arama / Katalog' },
            { keys: ['Ctrl', 'N'], description: 'Yeni ürün' },
            { keys: ['Ctrl', 'R'], description: 'Yenile' },
            { keys: ['Esc'], description: 'Kapat / İptal' },
        ]
    },
    {
        category: 'Navigasyon', shortcuts: [
            { keys: ['Alt', '←'], description: 'Geri git' },
            { keys: ['Alt', '→'], description: 'İleri git' },
            { keys: ['Tab'], description: 'Sonraki alana geç' },
            { keys: ['Shift', 'Tab'], description: 'Önceki alana geç' },
        ]
    },
    {
        category: 'Metin Düzenleme', shortcuts: [
            { keys: ['Ctrl', 'Z'], description: 'Geri al' },
            { keys: ['Ctrl', 'Y'], description: 'Yeniden yap' },
            { keys: ['Ctrl', 'A'], description: 'Tümünü seç' },
        ]
    }
];

function KeyboardShortcutsHelp() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // Ctrl+/ veya Ctrl+? ile aç/kapat
            if ((e.ctrlKey || e.metaKey) && (e.key === '/' || e.key === '?')) {
                e.preventDefault();
                setIsOpen(prev => !prev);
            }
            // Escape ile kapat
            if (e.key === 'Escape' && isOpen) {
                setIsOpen(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="shortcuts-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="shortcuts-modal"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-label="Klavye kısayolları"
                aria-modal="true"
            >
                <div className="shortcuts-header">
                    <h2>
                        <i className="fas fa-keyboard"></i>
                        Klavye Kısayolları
                    </h2>
                    <button
                        className="shortcuts-close"
                        onClick={() => setIsOpen(false)}
                        aria-label="Kapat"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="shortcuts-content">
                    {SHORTCUTS.map((category) => (
                        <div key={category.category} className="shortcuts-category">
                            <h3>{category.category}</h3>
                            <ul>
                                {category.shortcuts.map((shortcut, idx) => (
                                    <li key={idx}>
                                        <span className="shortcut-keys">
                                            {shortcut.keys.map((key, i) => (
                                                <React.Fragment key={i}>
                                                    <kbd>{key}</kbd>
                                                    {i < shortcut.keys.length - 1 && <span>+</span>}
                                                </React.Fragment>
                                            ))}
                                        </span>
                                        <span className="shortcut-desc">{shortcut.description}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="shortcuts-footer">
                    <kbd>Ctrl</kbd> + <kbd>/</kbd> ile bu paneli açıp kapatabilirsiniz
                </div>
            </div>
        </div>
    );
}

export default KeyboardShortcutsHelp;
